import { Component, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { UploaderOptions, UploadFile, UploadInput, UploadOutput, humanizeBytes } from 'ngx-uploader';

import { api } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';
import { SpinnerService } from '@bayclubs/spinner';

import { camps } from '../../../models/models.generated';
import { CampDefinitionApiService } from '../../../services/api/camp-definition-api.service';

@Component({
    selector: 'app-camp-import',
    templateUrl: './camp-import.component.html',
    styleUrls: ['./camp-import.component.scss'],
    host: { 'data-testid': 'camp-import-page' },
    standalone: false
})
export class CampImportComponent implements OnInit {
    files: UploadFile[];
    uploadInput: EventEmitter<UploadInput>;
    humanizeBytes: Function;
    dragOver: boolean;
    options: UploaderOptions;

    public importResult: api.OperationResultValue<camps.CampDefinitionFileImportResult>;
    public isVisibleToMembers: boolean = true;
    public showWarnings: boolean = false;

    @ViewChild('inputFile', { static: true }) inputElement: ElementRef;

    constructor(
        private api: CampDefinitionApiService,
        private alert: BayclubsAlertService,
        private spinner: SpinnerService,
        private router: Router
    ) {
        this.options = { concurrency: 1 };
        this.files = [];
        this.uploadInput = new EventEmitter<UploadInput>();
        this.humanizeBytes = humanizeBytes;
    }

    ngOnInit(): void {}

    goToDetails() {
        if (this.importResult.isSuccess && this.importResult.value) {
            this.router.navigate(['camps/' + this.importResult.value.campId + '/details']);
        }
    }

    onUploadOutput(output: UploadOutput): void {
        switch (output.type) {
            case 'allAddedToQueue':
                break;
            case 'addedToQueue':
                console.log(output);
                if (typeof output.file !== 'undefined') {
                    this.removeCurrentFile();
                    this.importResult = null;
                    this.showWarnings = false;
                    this.files.push(output.file);
                }
                break;
            case 'uploading':
                if (typeof output.file !== 'undefined') {
                    // update current data in files array for uploading file
                    const index = this.files.findIndex(
                        file => typeof output.file !== 'undefined' && file.id === output.file.id
                    );
                    this.files[index] = output.file;
                }
                break;
            case 'removed':
                // remove file from array when removed
                this.files = this.files.filter((file: UploadFile) => file !== output.file);
                this.resetFileInput();
                break;
            case 'dragOver':
                this.dragOver = true;
                break;
            case 'dragOut':
            case 'drop':
                this.dragOver = false;
                break;
            case 'done':
                // The file is downloaded
                break;
        }
    }

    startUpload(): void {
        this.import(this.files[0].nativeFile);
    }

    removeFile(id: string): void {
        this.uploadInput.emit({ type: 'remove', id: id });
        this.resetFileInput();
    }

    resetFileInput() {
        this.inputElement.nativeElement.value = null;
    }

    removeCurrentFile() {
        if (this.files.length > 0) {
            var current = this.files[0];

            this.files = this.files.filter((file: UploadFile) => file.id !== current.id);
        }
    }

    import(file: File) {
        this.spinner.show('');

        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e: ProgressEvent) => {
            var request = <camps.CampDefinitionFileImportRequest>{
                content: reader.result,
                fileName: file.name,
                isVisibleToMembers: this.isVisibleToMembers
            };

            request.content = request.content.split('base64,')[1];

            this.api.import(request).subscribe(x => {
                this.importResult = x;

                if (x.isSuccess) {
                    this.alert.showOperationSuccess();
                    this.files.length = 0;
                    this.removeCurrentFile();
                    this.resetFileInput();
                } else {
                    this.alert.showError('Import failed. Please look at log below.');
                }

                this.spinner.hide();
            });
        };
        reader.onerror = error => {
            this.spinner.hide();
            this.alert.showError('Error reading file.');
        };
    }

    fileSelected() {
        return this.files && this.files.length > 0;
    }

    onIsVisibleToMembersChanged(isVisible: boolean) {
        this.isVisibleToMembers = isVisible;
    }

    public onToggleWarningsClicked() {
        this.showWarnings = !this.showWarnings;
    }

    public showValidRevenueDepartmentHoldingAccountPairs(): boolean {
        if (this.importResult && this.importResult.validationNotification && this.importResult.validationNotification.errors) {
            return this.importResult.validationNotification.errors.some(item => 
                item.message == 'CampRevenueDepartmentMustBelongToHoldingAccount' || item.message == 'CampHoldingAccountMustBeValid'|| item.message == 'CampRevenueDepartmentMustBeValid');
        }

        return false;
    }
}
